import {useUserSettingsSitesGroup, useUserSettingsSitesGroupValidator} from "../../@hooks";
import {TextFieldSeeker} from "@ui-seeker/core";
import {userSettingsSitesGroupFormData} from "../../@signals";
import React from "react";

export default function UserSettingSitesGroupDrawerName() {
    const { handleChangeSitesGroupFormData } = useUserSettingsSitesGroup()
    const { nameError } = useUserSettingsSitesGroupValidator()

    return <TextFieldSeeker
        label="Name"
        error={nameError}
        value={userSettingsSitesGroupFormData.value?.name || []}
        onChange={e => handleChangeSitesGroupFormData(e.target.value, 'name')}
    />
}